const DIGITAL_PRACTICE_ACCESS = {
  NO_ACCESS: 'NO_ACCESS',
  HOME_ACCESS: 'HOME_ACCESS',
} as const;

type DigitalPracticeAccess =
  (typeof DIGITAL_PRACTICE_ACCESS)[keyof typeof DIGITAL_PRACTICE_ACCESS];

const isHomeAccess = (
  digitalPracticeAccess: DigitalPracticeAccess
): boolean => {
  return digitalPracticeAccess === DIGITAL_PRACTICE_ACCESS.HOME_ACCESS;
};

const isNoAccess = (digitalPracticeAccess: DigitalPracticeAccess): boolean => {
  return digitalPracticeAccess === DIGITAL_PRACTICE_ACCESS.NO_ACCESS;
};

export { DIGITAL_PRACTICE_ACCESS, isHomeAccess, isNoAccess };
export type { DigitalPracticeAccess };
